import React, { useContext, useEffect, useState, useRef } from 'react'

import { MeContext } from 'contexts/me'
import { generateProof } from 'utils/exportAsImage'

import { useActivityIDStore } from 'store'
import { getActivity, getEntity } from 'api/bank'
import List, { ListItem } from 'components/List'

import { moneyFormat, toTitleCase } from 'utils'

import Skeleton from 'react-loading-skeleton'
import Card from 'components/Card'
import Badge from 'components/Badge'
import TickIcon from 'components/listbox/SelectedIcon'
import PrimaryButton from 'components/primaryButton'
import { trackEvent } from 'analytics/trackFunctions'

const TransferActivityDetail = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [activityDetails, setActivityDetails] = useState(null)
  const [bankIconURL, setBankIconURL] = useState(null)
  const proofRef = useRef(null)

  const activityID = useActivityIDStore((state) => state.activityID)
  const { me } = useContext(MeContext)

  // get activity details
  useEffect(() => {
    if (activityDetails) return
    if (activityID) {
      trackEvent({ eventName: 'bille_pantalla_comprobante' })
      getActivity(activityID)
        .then((data) => {
          const entityCode = data.data.properties.destination_bank_code
          setActivityDetails(data)
          getEntity(entityCode).then((res) => {
            const { data } = res
            setBankIconURL(data.bank_image)
          })
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [activityID])

  const listItems = [
    {
      name: 'Origen',
      value: me?.bank?.internal_account[0]?.cvu
    },
    {
      name: 'Destino',
      value: activityDetails?.data?.properties?.destination_address
    },
    {
      name: 'Banco',
      value: (
        <span className='flex gap-1'>
          {!!bankIconURL && (
            <>
              <img className='rounded-full h-5 w-5' src={bankIconURL} alt='' />{' '}
            </>
          )}
          {activityDetails?.data?.properties?.destination_bank_name}
        </span>
      )
    },
    {
      name: 'Detalle',
      value: activityDetails?.data?.description
    }
  ]

  const transferDate = `${new Date(
    activityDetails?.created_at
  ).toLocaleDateString('es-AR', {
    dateStyle: 'long'
  })} - ${new Date(activityDetails?.created_at).toLocaleTimeString([], {
    timeStyle: 'short',
    hour12: false
  })}`

  return (
    <>
      <div id='proof' ref={proofRef} className='w-full'>
        {isLoading ? (
          <Skeleton height={200} />
        ) : (
          <Card
            id='proof-data'
            className='w-full text-center bg-white p-6 mt-4 lg:max-w-[25rem]'
          >
            <p className='text-gray-900 text-2xs font-medium'>
              Envío de dinero a
            </p>
            <p className='text-xl font-bold my-2'>
              {toTitleCase(
                activityDetails?.data?.properties?.destination_holder_name
              )}
            </p>
            <p className='text-gray-900 text-2xs font-bold'>{transferDate}</p>
            <p className='text-xl font-bold my-2'>
              {moneyFormat(activityDetails?.account_txs[0]?.total_amount)}
            </p>
            <Badge className='mx-auto' id='status-badge' variant='GREEN'>
              <TickIcon
                id='tick-icon'
                className='inline mr-1'
                stroke='#08724C'
              />
              <span id='status-text' className=''>
                Transferencia enviada
              </span>
            </Badge>
          </Card>
        )}

        <h2 className='mt-5 font-medium text-xs'>Detalles de la operación</h2>

        <List>
          {listItems.map((i, idx) => (
            <ListItem
              key={idx}
              name={i.name}
              value={i.value}
              isLoading={isLoading}
            />
          ))}
        </List>
      </div>

      <PrimaryButton
        className='mt-1'
        buttonText='Compartir'
        primaryButtonFunction={() => {
          trackEvent({ eventName: 'bille_comprobante_boton_compartir' })
          generateProof(proofRef.current)
        }}
      />
    </>
  )
}

export default TransferActivityDetail
